import { updateFeedbackRatingOptionsArgsToParams } from '@marketplace-web/conversation-feedback/conversation-feedback-data'

import { UpdateFaqEntryFeedbackArgs } from '../types/update-faq-entry-feedback'

export const updateFaqEntryFeedbackArgsToParams = ({
  feedbackUuid,
  accessChannel,
  ...feedbackRatings
}: UpdateFaqEntryFeedbackArgs) => ({
  feedback_uuid: feedbackUuid,
  access_channel: accessChannel,
  ...updateFeedbackRatingOptionsArgsToParams(feedbackRatings),
})
